import OnboardingProgressBarRoot, { Props } from './OnboardingProgressBar'

export default function OnboardingProgressBar(props: Props) {
  return <OnboardingProgressBarRoot {...props} />
}
